import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import type { Ref } from 'vue'
import { subscriptionsList } from '@/services/sub.service'
import useGlobal from '@/composables/useGlobal' 
import { STATE } from '@/utils/base64'
import executeWithRefresh from '@/composables/useRefresher'
import { sendChooseSubscription } from '@/analytics/ChooseSubscription'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepOne',
  props: ['paymentPage', 'getData', 'list'],
  emits: ['nextStep'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const { $t } = useGlobal()
const nextStep = ref({
  step: 2,
})
const subList = ref([])
const bestPrice = ref('')

onMounted(() => {
  setSubscription()
})

function percentDiff(a, b) {
  return Math.floor((a - b) / b * 100)
}

async function setNextStep(subscription) {
  await sendChooseSubscription(subscription.label)
  if (subscription) nextStep.value.sub = subscription
  if (props.paymentPage) {
    const data = {
      subscription_id: subscription.id,
    }
    window.location.href = `${props.paymentPage}?${STATE.stringify(data)}`
  }
  emit('next', nextStep)
}

async function setSubscription () {
  try {
    const res = (await executeWithRefresh(subscriptionsList, null))
    subList.value = res.data.items
    checkBestPrise(res.data.items)
    // getOrder()
  } catch(e) {
    return Promise.reject(e)
  }
}

function checkBestPrise(subArray = []) {
  const percents = ref([])
  subArray.forEach((element) => {
    percents.value.push(percentDiff(element.price_sale, element.price_default))
  });
  bestPrice.value = Math.min(...percents.value)
}

const getOrder = (item, i) => {
  const MIDDLE = 1
  const LAST = 3
  const r = (subList.value || props.list).sort((a, b) => {
    return percentDiff(b.price_sale, b.price_default) - percentDiff(a.price_sale, a.price_default)
  })
  if (r.findIndex(x => x.id == item.id) == MIDDLE) return LAST
}

  
const __returned__ = { props, emit, $t, nextStep, subList, bestPrice, percentDiff, setNextStep, setSubscription, checkBestPrise, getOrder, ref, onMounted, subscriptionsList, useGlobal, STATE, executeWithRefresh, sendChooseSubscription }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})